import { StoreType } from "@/store/store";
import { createSelector } from "reselect";

const settingStore = (state: StoreType) => state.setting;

export const paletteModeSelector = createSelector(
  settingStore,
  (setting) => setting.paletteMode
);
